export default "__VITE_ASSET__559ecdd9__"